import { render } from "./NewCustomer.vue?vue&type=template&id=11f8197c&scoped=true"
import script from "./NewCustomer.vue?vue&type=script&lang=js"
export * from "./NewCustomer.vue?vue&type=script&lang=js"

import "./NewCustomer.vue?vue&type=style&index=0&id=11f8197c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f8197c"]])

export default __exports__